import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ArrowIcon from 'assets/svg/red-right-arrow.svg';
import { RedTextButton } from 'components/buttons/RedTextButton';
import { useMultiStepForm } from 'components/form/MultiStepFormProvider';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';

const Container = styled(RedTextButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 0;
  height: auto;

  &:hover {
    opacity: 0.7;
  }
`;

const Icon = styled.img`
  width: 14px;
  height: 14px;
`;

const SkipButton = () => {
  const { t } = useTranslation();
  const { goToStep } = useMultiStepForm();
  const { isEditMode } = useBecomeFundraiser();

  const verifyContactDetailsStepIndex = isEditMode ? 4 : 5;
  return (
    <Container onClick={() => goToStep(verifyContactDetailsStepIndex)}>
      {t('skip')}
      <Icon src={ArrowIcon} />
    </Container>
  );
};

export default SkipButton;
